/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/house_value_medium'
export default icon
